import {Box, Grid, Typography} from "@mui/material";
import {motion} from "framer-motion";
import CourseBox from "./CourseBox";
import styles from "../global/header.module.css";
import {fontType} from "../../constants/font";
import {useInView} from "react-intersection-observer";

function CourseGroup({
    group,
    groupCourses,
    courses,
    fetchedCourseData,
    windowWidth,
 }) {
    const [descriptionAnimationRef, inViewDescription] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    const [coursesAnimationRef, inViewCourses] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    function getCourseGroupDescription(group) {
        if (group === 'top') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "15px",
                            lineHeight: "40px",
                        }}
                    >
                        Najpredávanejšie školenia
                    </Typography>
                </>
            )
        } else if (group === 'beginner') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "15px",
                            lineHeight: "40px",
                        }}
                    >
                        Začínam s testovaním – prvé kroky do IT
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                        }}
                    >
                        Pre úplných začiatočníkov, ktorí chcú pochopiť základy testovania a získať svoj prvý certifikát či prax.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                            marginTop: "20px"
                        }}
                    >
                        <span style={{ fontFamily: fontType.semiBold }}>Cieľ</span>: Získať pevné základy v testovaní, pochopiť procesy, terminológiu a začať kariéru ako junior tester.
                    </Typography>
                </>
            )
        } else if (group === 'advanced') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "15px",
                            lineHeight: "40px",
                        }}
                    >
                        Tester na ceste rastu – od juniora po skúseného profesionála
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                        }}
                    >
                        Pre tých, ktorí už testujú, majú základy (napr. CTFL) a chcú sa posunúť ďalej – do pokročilejšieho testovania, analýzy a riadenia tímu.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                            marginTop: "20px"
                        }}
                    >
                        <span style={{ fontFamily: fontType.semiBold }}>Cieľ</span>: Posun v kariére – od testera k analytikovi či manažérovi testovania.
                    </Typography>
                </>
            )
        } else if (group === 'automatization') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "15px",
                            lineHeight: "40px",
                        }}
                    >
                        Automatizácia a moderné prístupy v testovaní
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                        }}
                    >
                        Pre tých, ktorí chcú testovať efektívnejšie, využívať automatizáciu a najnovšie technológie vrátane GenAI.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                            marginTop: "20px"
                        }}
                    >
                        <span style={{ fontFamily: fontType.semiBold }}>Cieľ</span>: Osvojiť si moderné nástroje a princípy automatizácie – od skriptovania po AI-assisted testing.
                    </Typography>
                </>
            )
        } else if (group === 'itSpecialists') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "25px",
                            lineHeight: "40px",
                        }}
                    >
                        Testing pre IT špecialistov
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                        }}
                    >
                        Pre ľudí, ktorí už pracujú v IT (napr. vývojári, analytici, support), ale chcú lepšie porozumieť testovaniu a spolupráci s QA tímami.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                            marginTop: "20px"
                        }}
                    >
                        <span style={{ fontFamily: fontType.semiBold }}>Cieľ</span>: Získať praktický pohľad na testovanie z perspektívy vývoja a naučiť sa efektívne testovať dáta a logiku aplikácií.
                    </Typography>
                </>
            )
        } else if (group === 'agile') {
            return (
                <>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.semiBold,
                            fontSize: 38,
                            color: "#1d1a56",
                            marginBottom: "15px",
                            lineHeight: "40px",
                        }}
                    >
                        Agilita a testovanie v tíme
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                        }}
                    >
                        Pre tých, ktorí chcú pochopiť agilné prostredie, scrum procesy a rolu testera v tíme.
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontFamily: fontType.regular,
                            fontSize: 22,
                            lineHeight: "28px",
                            color: "#1d1a56",
                            marginTop: "20px"
                        }}
                    >
                        <span style={{ fontFamily: fontType.semiBold }}>Cieľ</span>: Naučiť sa testovať v agilnom tíme, komunikovať s vývojom a podporovať rýchle dodávky kvalitného softvéru.
                    </Typography>
                </>
            )
        }
    }

    return (
        <Box
            id={group}
            sx={{
                backgroundColor: "#d8d8d8",
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    maxWidth: "1440px",
                    width: "100%",
                    position: "relative",
                }}
            >
                <motion.div
                    ref={descriptionAnimationRef}
                    initial={{ opacity: 0, y: 50 }}
                    animate={inViewDescription ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                    transition={{ duration: 0.7 }}
                >
                    <Box
                        sx={{
                            marginTop: { sm: "60px", xs: "35px" },
                            marginBottom: "50px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 2,
                            position: "relative",
                            paddingLeft: windowWidth < 2700 ? "9vw" : "0",
                            paddingRight: windowWidth < 2700 ? "9vw" : "0",
                        }}
                    >
                        { getCourseGroupDescription(group) }
                    </Box>
                </motion.div>
                <motion.div
                    ref={coursesAnimationRef}
                    initial={{ opacity: 0, y: 50 }}
                    animate={inViewCourses ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                    transition={{ duration: 0.7 }}
                >
                    <Grid
                        container
                        sx={{
                            paddingLeft: windowWidth < 2700 ? "9vw" : "0",
                            paddingRight: windowWidth < 2700 ? "9vw" : "0",
                            position: "relative",
                            zIndex: 2,
                            display: "flex",
                            justifyContent: { lg: "center", xs: "center" },
                            alignItems: "center",
                            gap: "50px",
                            marginBottom: "60px",
                        }}
                    >
                        {groupCourses.map(courseCode => {
                            const course = courses.find((course) => course.code === courseCode);
                            const courseData = fetchedCourseData.find((courseData) => courseData.code === course.code);

                            return (
                                <CourseBox
                                    key={`${courseCode}-${courseData?.id}`}
                                    course={course}
                                    courseData={courseData}
                                    group={group}
                                />
                            )
                        })}
                    </Grid>
                </motion.div>
                <img
                    className={styles.element}
                    style={{
                        position: "absolute",
                        top: 100,
                        zIndex: 1,
                    }}
                    src={require("../../assets/elements2.png")}
                    alt="academy_logo"
                />
                <div
                    style={{
                        position: "absolute",
                        bottom: 100,
                        zIndex: 1,
                        transform: "scaleX(-1)",
                    }}
                >
                    <img className={styles.element} src={require("../../assets/elements2.png")} alt="academy_logo_bottom" />
                </div>
            </Box>
        </Box>
    )
}

export default CourseGroup;